var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 39,
    viewBox: "0 0 49 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.3333 4.5724C46.5218 5.36356 44.6031 5.88232 42.6397 6.11182C44.7005 4.90163 46.2503 2.98249 46.9993 0.712982C45.0467 1.84961 42.917 2.65019 40.6991 3.08132C39.7652 2.10306 38.6417 1.32534 37.3973 0.79558C36.1529 0.265825 34.8136 -0.0048511 33.4612 6.58042e-05C27.985 6.58042e-05 23.5456 4.37423 23.5456 9.7634C23.5456 10.5271 23.6326 11.2738 23.8018 11.9867C19.8736 11.7999 16.0276 10.7963 12.5091 9.03994C8.99053 7.28359 5.87675 4.81305 3.36642 1.78598C2.48633 3.27079 2.02375 4.96579 2.02758 6.69182C2.02758 10.0824 3.77725 13.0718 6.43558 14.8191C4.8635 14.7683 3.32538 14.3486 1.94542 13.5938V13.7147C1.94542 18.4465 5.365 22.3929 9.89625 23.2919C9.04464 23.5179 8.16732 23.6324 7.28625 23.6326C6.64583 23.6326 6.02475 23.5722 5.41817 23.4514C6.06604 25.4039 7.30584 27.1062 8.96539 28.3218C10.6249 29.5375 12.6219 30.2061 14.6788 30.235C11.1507 32.9526 6.8194 34.4208 2.36592 34.4086C1.56358 34.4086 0.77575 34.3602 0 34.2732C4.54636 37.1508 9.81793 38.6747 15.1984 38.6667C33.437 38.6667 43.4082 23.7873 43.4082 10.8847L43.3743 9.62082C45.3194 8.25219 46.9997 6.54161 48.3333 4.5724Z",
    fill: "#0079BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.6e027d23cd5d1b02e153fa4a12db5066.svg";
export { ForwardRef as ReactComponent };